import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import AppsIcon from '@material-ui/icons/Apps';
import { AppsPage } from './AppsPage';

// routeRef explícito é obrigatório para aparecer no menu lateral (ver o
// comentário em ../users/index.tsx). A visibilidade do item para quem não é admin
// é decidida em ../users/index.tsx (FilteredNavContent), com a mesma permissão da
// página Pipelines: ligar e desligar aplicações é ação de administrador.
export const appsRouteRef = createRouteRef();

const appsPage = PageBlueprint.make({
  name: 'apps',
  params: {
    path: '/apps',
    title: 'Aplicações',
    icon: <AppsIcon />,
    routeRef: appsRouteRef,
    loader: async () => <AppsPage />,
  },
});

export const appsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [appsPage],
});
